import { createHashHistory } from 'history';
// eslint-disable-next-line no-restricted-globals
const history = createHashHistory();
// eslint-disable-next-line no-restricted-globals
history.listen((_) => {
	if (window.DD_RUM) {
		window.DD_RUM.startView({
			name: _.pathname,
			service: 'postpe',
			version: '5.3.0'
		});
	}
	window.scrollTo(0, 0);
});

export default history;
